export default "__VITE_ASSET__BKJ9AemT__"